// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"66":"b6df7107466cf441","328":"1f7fa5e5c32d0abb","535":"bbd0bb56ef89c973","585":"71390480b5603e6c","627":"3380924e5c86f0c6","661":"529b7a054a4f9896","674":"ca953a08d829b901","694":"3b587df150bf560e"}[chunkId] + ".js";
};